import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const eastTampaConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'East Tampa Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in East Tampa, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_east_tampa',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving East Tampa',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in East Tampa Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the residential neighborhoods 
     and commercial corridors of <strong>East Tampa</strong> with dependable, 
     professional tree care. This established community has mature trees throughout 
     its streets and when Florida storm season hits, those trees become serious 
     hazards for homes, fences, and vehicles fast. Our team steps in with the 
     right tools and a safety first approach every time.`,

    `We specialize in <strong>dangerous tree removal and precision trimming</strong> 
     large overhanging limbs near rooftops, storm split trunks, trees with root 
     damage leaning toward structures, and heavy canopy overgrowth that creates 
     real wind load risk. We handle every phase from assessment to final cleanup.`,

    `<strong>Sam's Tree Service</strong> provides trusted, affordable tree care 
     throughout <strong>East Tampa</strong> and across <strong>Hillsborough 
     County</strong> protecting your property and keeping your trees in 
     great shape all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'East Tampa, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_EastTampa = () => <LocationPage config={eastTampaConfig} />;
export default Services_EastTampa;
